import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=0b712669&scoped=true"
import script from "./payResult.vue?vue&type=script&lang=js"
export * from "./payResult.vue?vue&type=script&lang=js"
import style0 from "./payResult.vue?vue&type=style&index=0&id=0b712669&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b712669",
  null
  
)

export default component.exports